import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EditFlowControllerPage } from './edit-flow-controller.page';

const routes: Routes = [
  {
    path: '',
    component: EditFlowControllerPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EditFlowControllerPageRoutingModule {}
